import { IStorageTypes } from '../models';

export enum LocalStorageKeyTypes {
	TOKEN = 'token',
	dashboardSurveyRoundId = 'dashboardSurveyRoundId',
}

export enum SessionStorageKeyTypes {
	breadCrumbs = 'breadCrumbs',
	respondentId = 'respondentId',
	templateFormData = 'templateFormData',
	partnersDB = 'partnersDB',
	pickedIdList = 'pickedIdList',
	schedulingFormData = 'schedulingFormData',
	isNavbarExpanded = 'isNavbarExpanded',
	clientId = 'clientId',
	partnerId = 'partnerId',
	templateId = 'templateId',
	surveyId = 'surveyId',
	isCopy = 'isCopy',
	templateSchedulingData = 'templateSchedulingData',
	dashboardSurveyId = 'dashboardSurveyId',
	dashboardPersonaId = 'dashboardPersonaId',
	dashboardSurveyRoundId = 'dashboardSurveyRoundId',
	dashboardPersonaName = 'dashboardPersonaName',
	dashboardCommentId = 'dashboardCommentId',
	dashboardServiceId = 'dashboardServiceId',
	dashboardRoleId = 'dashboardRoleId',
	surveyName = 'surveyName',
	formDataClientId = 'formDataClientId',
	emailEditingStep = 'emailEditingStep',
	templateType = 'templateType',
	emailType = 'emailType',
	currentPointAlign = 'currentPointAlign',
	pointAligns = 'pointAligns',
}

export function removeFromSessionStorage(key: SessionStorageKeyTypes) {
	removeData('sessionStorage', key);
}

export function saveToSessionStorage(
	key: SessionStorageKeyTypes,
	data: Object,
) {
	return saveData('sessionStorage', key, data);
}

export function getFromSessionStorage(key: SessionStorageKeyTypes) {
	return getData('sessionStorage', key);
}

export function saveToLocalStorage(
	key: LocalStorageKeyTypes,
	data: Object | string,
) {
	return saveData('localStorage', key, data);
}

export function getFromLocalStorage(key: LocalStorageKeyTypes) {
	return getData('localStorage', key);
}

function saveData(
	storage: IStorageTypes,
	key: string,
	newData: Object | string,
) {
	if (storage === 'cookie') {
		return;
	}

	if (typeof newData === 'string') {
		window[storage].setItem(key, newData);
	} else {
		window[storage].setItem(key, JSON.stringify(newData));
	}
}

function getData(storage: IStorageTypes, key: string) {
	if (storage === 'cookie') {
		return null;
	}

	const data = window[storage].getItem(key);

	if (data) {
		try {
			return JSON.parse(data);
		} catch (e) {
			return data;
		}
	}

	return null;
}

function removeData(storage: IStorageTypes, key: string) {
	if (storage === 'cookie') {
		return;
	}
	window[storage].removeItem(key);
}
